import { memo } from 'react';
import { ConfirmDialog } from '@dfl/mui-admin-layout';
import { useSecurity } from '@dfl/react-security';
import { ArrowForwardOutlined } from '@mui/icons-material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import { DetailsIcon, TrashIcon } from 'components/SvgIcons';
import useRowAction from 'hooks/useRowAction';
import useTableMenuOptions from 'modules/audit/management/hooks/useTableMenuOptions';
import ActionTableMenu from 'modules/common/components/ActionTableMenu/ActionTableMenu';
import { useTranslation } from 'react-i18next';
import { AuditStatus } from '../../interfaces';
type Props = {
  rowId: string;
  record: any;
};

const AuditRowActions = ({ rowId, record }: Props) => {
  const { t } = useTranslation('common');
  const { handleDuplicate, handleContinue, handleDetails, handleConfirm, isLoading, error, isOpen, onClose, onOpen } =
    useTableMenuOptions(rowId);
  const { openTooltip, setOpenTooltip, handleAction } = useRowAction();
  const { hasPermission } = useSecurity();

  return (
    <>
      <ConfirmDialog
        confirmButtonText={t('accept')}
        title={t('deleteConfirmation.title')}
        onConfirm={handleConfirm}
        confirmationMessage={t('deleteConfirmation.confirmation')}
        isLoading={isLoading}
        error={error}
        onClose={onClose}
        open={isOpen}
      />
      <ActionTableMenu onClose={handleAction} open={openTooltip} setOpenTooltip={setOpenTooltip}>
        <MenuItem
          onClick={() => {
            handleAction(handleDetails);
          }}
        >
          <ListItemIcon>
            <DetailsIcon />
          </ListItemIcon>
          <Typography color='secondary'>{t('viewDetails')}</Typography>
        </MenuItem>
        {record.status === AuditStatus.IN_PROGRESS && (
          <MenuItem
            onClick={() => {
              handleAction(handleContinue);
            }}
          >
            <ListItemIcon>
              <ArrowForwardOutlined />
            </ListItemIcon>
            <Typography color='secondary'>{t('continue')}</Typography>
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleAction(handleDuplicate);
          }}
        >
          <ListItemIcon>
            <ContentCopyIcon />
          </ListItemIcon>
          <Typography color='secondary'>{t('duplicate')}</Typography>
        </MenuItem>
        {(record.status === AuditStatus.DRAFT || hasPermission('USER_ADMIN')) && (
          <MenuItem
            onClick={() => {
              handleAction(onOpen);
            }}
          >
            <ListItemIcon>
              <TrashIcon />
            </ListItemIcon>
            <Typography color='secondary'>{t('delete')}</Typography>
          </MenuItem>
        )}
      </ActionTableMenu>
    </>
  );
};

export default memo(AuditRowActions);
